interface IValidationErrorItem {
	field?: string
	message?: string
	code?: string
}

/**
 * Device conflicts the backend reports on the deviceId field. Each means something different to
 * a dispatcher, so they cannot share one message: DEVICE_RUNNING means the vehicle is out right
 * now, while DEVICE_BOOKED means it is free and the problem is the voyage already planned on it.
 */
const DEVICE_ERROR_LABELS: Record<string, string> = {
	DEVICE_RUNNING: 'singleVoyage.deviceBusyOnStart',
	DEVICE_BOOKED: 'singleVoyage.deviceBookedForPlannedVoyage',
	DEVICE_WINDOW_OVERLAP: 'singleVoyage.deviceWindowOverlap',
}

/**
 * Translation key for a device conflict, or undefined when the error is something else and the
 * generic message should be shown. Matching on the code rather than the English text keeps this
 * from breaking when the backend wording changes.
 */
export const getDeviceErrorLabelKey = (error: unknown): string | undefined => {
	const errors = (error as { errors?: IValidationErrorItem[] })?.errors

	if (!Array.isArray(errors)) {
		return undefined
	}

	return errors
		.map((item) => (item?.code ? DEVICE_ERROR_LABELS[item.code] : undefined))
		.find(Boolean)
}
